export function getCookie(cname) {
    var regEx = new RegExp('(^|;)\\s*' + cname + '\\s*=\\s*([^;]+)'),
        matches = document.cookie.match(regEx);

    return matches ? decodeURIComponent(matches.pop()) : '';
}

export function setCookie(cname, cvalue, exdays) {
    var hostname = window.location.hostname.split('.');
    hostname.shift();
    var domain = hostname.join('.');
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    document.cookie = cname + "=" + encodeURIComponent(cvalue) + ";expires=" + d.toUTCString() + ";domain=" + domain + ";path=/";
}

export function deleteCookies(excludeNames) {
    excludeNames = excludeNames || [];
    var cookies = document.cookie.split(";");
    var hostname = window.location.hostname.split('.');
    hostname.shift();
    var domain = hostname.join('.');

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = (eqPos > -1 ? cookie.substr(0, eqPos) : cookie).trim();
        if (excludeNames.indexOf(name) < 0) {
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/"; // domain with subdomain
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + domain + ";path=/"; // domain without subdomain
        }
    }
}